import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Modal, Button, Form, InputGroup, FormControl } from 'react-bootstrap';
import { Steps, Dropdown, Menu } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import './participantList.css'; // Import your CSS file
import axios from 'axios';
import Swal from 'sweetalert2';

const { Step } = Steps;

const ParticipantList = ({ setShowSpinner, id }) => {
  const [searchTerm, setSearchTerm] = useState(''); // State for search term
  const [searchBy, setSearchBy] = useState('organizationName'); // State for search criterion
  // Dummy data for participants
  const [participants, setParticipants] = useState([]);
  const [adminStudy, setAdminStudy] = useState(null);;

  //Bearer Token
  const token = localStorage.getItem('token');
  const tokenValue = token ? token.slice(1, token.length - 1) : "";
  const getData = (token) => {
    setShowSpinner(true);
    axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/myStudy/${id}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
          // You can add other headers if needed like authorization token, etc.
        }
      })
      .then(res => {
        const response = res.data.data
        setParticipants(response);
      })
      .catch(error => {
        console.log(error.response?.data?.message);
      })
      .finally(() => {
        setShowSpinner(false);
      })

    //Bring Admin StudyObj
    axios.post(`https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/specific`,
      {
        _id: id
      }, {
      headers: {
        'Authorization': `Bearer ${tokenValue}`
        // You can add other headers if needed like authorization token, etc.
      }
    })
      .then(res => {
        const response = res.data.data
        setAdminStudy(response);
      })
      .catch(error => {
        console.log(error.response?.data?.message);
      })
      .finally(() => {
        setShowSpinner(false);
      })
  }

  useEffect(() => {
    getData(tokenValue);
  }, [])

  const giveMeStepNo = (item) => {
    // Calculate the highest valid step outside of render
    let step = 0;
    const steps = [1, 2, 3, 4, 5, 6, 7];
    for (const s of steps) {
      if (item[`step${s}`]?.clear) {
        step = s;
      }
    }
    return step;
  }

  // Map steps to their respective document fields
  const stepDocumentMap = {
    step1: 'step1Doc',
    step2: 'step2Doc',
    step3: 'step3Doc',
    step4: 'step4Doc',
    step5: 'step5Doc',
    step6: 'step6Doc',
    step7: 'step7Doc',
  };

  const handleMenuClick = (action, step, mystudyId) => {
    if (action === 'move to next') {
      moveUserToNextStep(step, mystudyId)

    } else if (action === 'upload') {
      uploadDocument(step, mystudyId)
    }
  };


  const moveUserToNextStep = (step, mystudyId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, move him!"
    }).then((result) => {
      if (result.isConfirmed) {
        setShowSpinner(true);
        // Create the object to be used for updating
        const obj = { [`${step}.clear`]: true };
        // URL for saving study information
        const saveUrl = `https://research-mate-b35a10757d5a.herokuapp.com/api/myStudy/moveToNextStep/${mystudyId}`;

        // Make the API request to save study information
        axios.post(saveUrl, obj, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${tokenValue}`
          }
        })
          .then(res => {
            getData(tokenValue)
            Swal.fire({
              title: "Moved!",
              text: "User has been moved to next step",
              icon: "success",
              customClass: {
                container: 'swal2-container-custom'
              }
            });
          })
          .catch(error => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.response.data.message || error.message,
              customClass: {
                container: 'swal2-container-custom'
              }
            });
          })
          .finally(() => {
            setShowSpinner(false);
          })
      }
    });

  }

  const uploadDocument = (step, mystudyId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, upload it!"
    }).then((result) => {
      if (result.isConfirmed) {
        setShowSpinner(true);
        // Get the document field based on the step
        const docField = stepDocumentMap[step];
        // Check if the document field exists in adminStudy and is valid
        if (!adminStudy[0][docField]) {
          setShowSpinner(false);
          return Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `You have not uploaded the document of this step`,
            customClass: {
              container: 'swal2-container-custom'
            }
          });
        }
        // Create the object to be used for updating
        const obj = { [`${step}.adminDocument`]: adminStudy[0][docField] };
        // URL for saving study information
        const saveUrl = `https://research-mate-b35a10757d5a.herokuapp.com/api/myStudy/adminDoc/${mystudyId}/${step}`;
        // Make the API request to save study information
        axios.post(saveUrl, obj, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${tokenValue}`
          }
        })
          .then(res => {
            getData(tokenValue)
            Swal.fire({
              title: "Added!",
              text: "Document has been uploaded",
              icon: "success",
              customClass: {
                container: 'swal2-container-custom'
              }
            });
          })
          .catch(error => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.response.data.message || error.message,
              customClass: {
                container: 'swal2-container-custom'
              }
            });
          })
          .finally(() => {
            setShowSpinner(false);
          })
      }
    });

  }

  const renderStepWithMenu = (title, showDiscription, userDoc, adminDoc, step, mystudyId) => {
    return (
      <Step
        title={title}
        description={showDiscription ?
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="1"
                  onClick={e => {
                    adminDoc ?
                      console.log('document already uploaded')
                      :
                      handleMenuClick('upload', step, mystudyId)
                  }}
                  step={step}>
                  {adminDoc ? <span style={{ color: "grey" }}>Uploaded</span> : 'Upload'}
                </Menu.Item>
                <Menu.Item key="2">
                  {userDoc ?
                    <a href={userDoc} target='_blank' download={'Current_StepDoc'}>
                      Download
                      <span style={{ color: 'green', fontSize: '24px' }} >•</span>
                    </a>
                    : ' Download'}
                </Menu.Item>
                <Menu.Item key="3" onClick={e => handleMenuClick('move to next', step, mystudyId)} step={step}>
                  Move to Next
                </Menu.Item>
              </Menu>
            }
            trigger={['click']}
          >
            <EllipsisOutlined style={{ fontSize: '24px', cursor: 'pointer' }} />
          </Dropdown>
          : <></>
        }
      />
    )
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearchByChange = (e) => {
    setSearchBy(e.target.value);
  };


  const filteredParticipants = participants.length !== 0 ? participants.filter((participant) => {
    if (searchBy === 'organizationName') {
      return participant.user.organizationName.toLowerCase().includes(searchTerm.toLowerCase());
    } else if (searchBy === 'pi') {
      return participant.pi.toLowerCase().includes(searchTerm.toLowerCase());
    } else if (searchBy === 'email') {
      return participant.user.email.toLowerCase().includes(searchTerm.toLowerCase());
    }
    return false;
  }) : [];


  return (
    <div className='p-2'>
      <InputGroup className="mb-3">
        <FormControl
          placeholder="Search..."
          aria-label="Search"
          aria-describedby="basic-addon2"
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <Form.Select aria-label="Search by" value={searchBy} onChange={handleSearchByChange}>
          <option value="organizationName">Organization Name</option>
          <option value="pi">PI</option>
          <option value="email">Email</option>
        </Form.Select>
      </InputGroup>
      <div className='grid-custom'>


        {filteredParticipants.map((participant, index) => {
          const currentStep = giveMeStepNo(participant);
          return (
            <Card className='mt-2' key={index}>
              <Card.Body>
                <Row>
                  <Col>
                    <h6>Name</h6>
                    <p>{participant.user.firstName} {participant.user.lastName}</p>
                  </Col>
                  <Col>
                    <h6>Organization Name</h6>
                    <p>{participant.user.organizationName}</p>
                  </Col>
                  <Col>
                    <h6>Organization Type</h6>
                    <p>{participant.user.organizationType}</p>
                  </Col>
                  <Col>
                    <h6>Active Date</h6>
                    <p>{participant.adminStudy.activationDate}</p>
                  </Col>
                  {/* <Col>
                  <h6>Recent Activity</h6>
                  <p>{participant.recentActivity}</p>
                </Col> */}
                  <Col>
                    <h6>Email</h6>
                    <p>{participant.user.email}</p>
                  </Col>
                  <Col>
                    <h6>Study Manager</h6>
                    <p>{participant.adminStudy.manager}</p>
                  </Col>
                  <Col>
                    <h6>PI</h6>
                    <p>{participant.pi}</p>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <Row>
                  <Col>
                    <Steps current={currentStep} className="custom-steps">
                      {
                        currentStep === 0 ?
                          renderStepWithMenu(
                            "SMO",
                            true,
                            participant.step1.userDocument,
                            participant.step1.adminDocument,
                            'step1',
                            participant._id
                          )
                          :
                          renderStepWithMenu(
                            "SMO",
                            false,
                            participant.step1.userDocument,
                            participant.step1.adminDocument,
                            'step1',
                            participant._id
                          )
                      }
                      {
                        currentStep === 1 ?
                          renderStepWithMenu(
                            "CDA",
                            true,
                            participant.step2.userDocument,
                            participant.step2.adminDocument,
                            'step2',
                            participant._id
                          )
                          :
                          renderStepWithMenu(
                            "CDA",
                            false,
                            participant.step2.userDocument,
                            participant.step2.adminDocument,
                            'step2',
                            participant._id
                          )
                      }
                      {
                        currentStep === 2 ?
                          renderStepWithMenu(
                            "Protocol/FQ",
                            true,
                            participant.step3.adminDocument,
                            participant.step3.adminDocument,
                            'step3',
                            participant._id
                          )
                          :
                          renderStepWithMenu(
                            "Protocol/FQ",
                            false,
                            participant.step3.userDocument,
                            participant.step3.adminDocument,
                            'step3',
                            participant._id
                          )
                      }
                      {
                        currentStep === 3 ?
                          renderStepWithMenu(
                            "PSSV",
                            true,
                            participant.step4.userDocument,
                            participant.step4.adminDocument,
                            'step4',
                            participant._id
                          )
                          :
                          renderStepWithMenu(
                            "PSSV",
                            false,
                            participant.step4.userDocument,
                            participant.step4.adminDocument,
                            'step4',
                            participant._id
                          )
                      }
                      {
                        currentStep === 4 ?
                          renderStepWithMenu(
                            "Budget/CTA",
                            true,
                            participant.step5.userDocument,
                            participant.step5.adminDocument,
                            'step5',
                            participant._id
                          )
                          :
                          renderStepWithMenu(
                            "Budget/CTA",
                            false,
                            participant.step5.userDocument,
                            participant.step5.adminDocument,
                            'step5',
                            participant._id
                          )
                      }
                      {
                        currentStep === 5 ?
                          renderStepWithMenu(
                            "SIV",
                            true,
                            participant.step6.userDocument,
                            participant.step6.adminDocument,
                            'step6',
                            participant._id
                          )
                          :
                          renderStepWithMenu(
                            "SIV",
                            false,
                            participant.step6.userDocument,
                            participant.step6.adminDocument,
                            'step6',
                            participant._id
                          )
                      }
                      {
                        currentStep === 6 ?
                          renderStepWithMenu(
                            "Invoicing",
                            true,
                            participant.step7.userDocument,
                            participant.step7.adminDocument,
                            'step7',
                            participant._id
                          )
                          :
                          renderStepWithMenu(
                            "Invoicing",
                            false,
                            participant.step7.userDocument,
                            participant.step7.adminDocument,
                            'step7',
                            participant._id
                          )
                      }
                    </Steps>
                  </Col>
                </Row>
              </Card.Footer>
            </Card>
          )
        })}
      </div>
    </div>
  );
};

export default ParticipantList;
